<template>
  <v-flex>
  <v-dialog v-model="dialogFormularioReserva" :width="dialogWidth" persistent>
      <reserva-formulario
        :modelReserva="this.modelReserva"
        :accion="this.accionReserva"
        @cerrarFormularioReserva="dialogFormularioReserva = false"
        @cerrar="dialogFormularioReserva = false"
      />
    </v-dialog>

  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
        <h5 v-bind:style="{ color: 'white' }">PERFIL DEL CLIENTE</h5>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tooltip v-if="modelCliente.email" bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            @click="_enviarEmail(modelCliente)"
            :color="colorEBikeAccent1"
            class="mt-1 mb-1 mr-2"
            v-on="on"
            >mdi-email</v-icon
          >
        </template>
        <span>Enviar Correo</span>
      </v-tooltip>

      <v-tooltip v-if="modelCliente.telefono" bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            @click="_abrirWh(modelCliente)"
            :color="colorEBikeAccent1"
            class="mt-1 mb-1 mr-4"
            v-on="on"
            >mdi-whatsapp</v-icon
          >
        </template>
        <span>Enviar Whatsapp</span>
      </v-tooltip>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana"
        >mdi-close-circle</v-icon
      >
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>
        <v-col class="ml-0">
          <v-row dense class="mx-4">
            <v-text-field
              v-model="modelCliente.nombre"
              outlined
              label="Nombre"
              dense
              :dark="dark"
              autocomplete="off"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field
              outlined
              dense
              :dark="dark"
              autocomplete="off"
              v-model="modelCliente.telefono"
              label="Teléfono"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field
              outlined
              dense
              v-model="modelCliente.email"
              :dark="dark"
              label="Email"
              maxlength="150"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field
              outlined
              dense
              v-model="modelCliente.dni"
              :dark="dark"
              label="Dni"
              maxlength="150"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field
              outlined
              dense
              v-model="modelCliente.domicilio"
              :dark="dark"
              label="Domicilio"
              maxlength="150"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-textarea
              outlined
              v-model="modelCliente.observaciones"
              :dark="dark"
              label="Observaciones"
            ></v-textarea>
          </v-row>

          <v-row dense class="mx-4">
            <v-switch
              hide-details
              v-model="modelCliente.agencia"
              label="¿Es agencia?"
            ></v-switch>
          </v-row>
        </v-col>

        <v-divider
          v-if="
            modelCliente &&
            modelCliente.reservas &&
            modelCliente.reservas.length > 0
          "
          class="ml-4 mr-4 mt-0"
          :dark="dark"
          vertical
        />

        <v-col
          class="ml-4 mr-2"
          v-if="
            modelCliente &&
            modelCliente.reservas &&
            modelCliente.reservas.length > 0
          "
        >
          <v-row>
            <v-data-table
              v-if="modelCliente.reservas"
              dense
              hide-default-footer
              hide-default-header
              :headers="headersLargo"
              :items="modelCliente.reservas"
              :items-per-page="300"
              class="elevation-0 mt-2"
              :group-by="['fecha_inicial']"
            >
              <template v-slot:group="{ items }">
                <tr v-for="item in items" :key="item.id" v-show="!item.hide">
                  <td
                    v-bind:style="{ color: 'white', background: colorAccent1 }"
                  >
                    <v-row class="mx-2">
                      <span style="color: white; font-size: 12px">{{
                        item["fecha_inicial"] + " ___ " + item["fecha_final"]
                      }}</span>
                    </v-row>
                  </td>

                  <td >
                    <v-chip
                      small
                      class="mt-1 mb-1"
                      :color="colorAccent2"
                      style="color: white;
                        font-weight: bold;
                        text-align: center;
                      "
                      link
                      @click="_editarReserva(item)"
                      >{{
                        "Cant de bicis: " +
                        (item["cant_bicis_s"] +
                          item["cant_bicis_m"] +
                          item["cant_bicis_l"] +
                          item["cant_bicis_xl"] +
                          item["cant_bicis_ms"] + 
                          item["cant_bicis_mm"]  + 
                          item["cant_bicis_ml"] 
                          )
                      }}</v-chip
                    >
                  </td>
                </tr>
              </template>

              <template v-slot:no-data>
                <v-row class="mt-1 ml-4" justify="start" dense></v-row>
              </template>
            </v-data-table>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mx-4 mb-2">
        <v-spacer></v-spacer>
        <v-chip
          class="mr-1 px-10"
          label
          :color="colorEBikeAccent1"
          text-color="white"
          link
          @click="_guardarCliente"
        >
          <h5 v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</h5>
          <h5 v-else v-bind:style="{ color: 'white' }">Guardar</h5>
        </v-chip>
      </v-row>
    </v-card-text>
  </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ReservaFormulario from "./ReservaFormulario.vue";


export default {
  name: "ClienteFormulario",
  components: {
    ReservaFormulario,
  },
  data: () => ({
    loading: false,
    headersLargo: [
      {
        text: "fecha_inicial",
        align: "center",
        sortable: false,
        value: "fecha_inicial",
      },
      {
        text: "fecha_final",
        align: "left",
        sortable: false,
        value: "fecha_final",
      },
      {
        text: "cant_bicis_s",
        align: "center",
        sortable: false,
        value: "cant_bicis_s",
      },
    ],
    modelReserva: null,
    accionReserva: null,
    dialogFormularioReserva: false,
  }),

  props: {
    modelCliente: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",

      "colorEBikeAccent1",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("reservas", ["dialogWidth", "reservaSelec"]),
  },

  /*modelCliente() {
      if (this.modelCliente.id == null) {
        this.accion = "crear";
      } else {
        this.accion = "editar";
      }
    }, */

  mounted() {
    /* if (this.modelCliente.id == null) {
      this.accion = "crear";
    } else {
      this.accion = "editar";
    }*/
  },

  methods: {
    ...mapActions("clientes", ["crearCliente", "updateCliente"]),
    ...mapMutations("reservas", [
      "setReservaSelec",
    ]),

    _enviarEmail(item) {
      if (item.email != null) {
        require("electron").shell.openExternal(
          "https://mail.google.com/mail?view=cm&tf=0&to=" + item.email
        );
      }
    },

    _abrirWh(item) {
      if (item.telefono != null) {
        require("electron").shell.openExternal(
          "https://api.whatsapp.com/send?phone=34" + item.telefono.replace(" ", ""),
          "_blank"
        );
      }
    },

    _editarReserva(item) {
      this.setReservaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.reservaSelec));
      this.modelReserva = temp;
      console.log("modelReserva", this.modelReserva);
      this.accionReserva = "editar";
      this.dialogFormularioReserva = true;
    },

    _captionFecha(item) {
      if (item && item.fecha) {
        return (
          this._diasemana(item.fecha) +
          " " +
          item.fecha.substring(8, 10) +
          "-" +
          item.fecha.substring(5, 7) +
          "-" +
          item.fecha.substring(0, 4)
        );
      } else {
        return "";
      }
    },

    _diasemana(date) {
      let days = [
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
        "Domingo",
      ];
      let d = new Date(date.substring(0, 10));
      let dd = d.getUTCDay();
      if (dd > 0) {
        return days[d.getUTCDay() - 1];
      } else {
        return days[6];
      }
    },

    _cerrarVentana() {
      this.$emit("cerrarFormularioCliente");
    },

    async _guardarCliente() {
      this.loading = true;
      if (this.accion == "crear") {
        var res = await this.crearCliente([
          this.access_token,
          this.modelCliente,
        ]);
        this._cerrarVentana();
        this.$emit("clienteGuardado");
      } else if (this.accion == "editar") {
        var res = await this.updateCliente([
          this.access_token,
          this.modelCliente,
        ]);
        this._cerrarVentana();
        this.$emit("clienteGuardado");
      }
      this.loading = false;
    },
  },
};
</script>
